import * as actionTypes from '../actions/actionTypes';

export default function countryFormInfo(state = {}, action) {
  switch(action.type){
    case actionTypes.SET_COUNTRY_FORM_TAB_INDEX: {
      let newState = {...state};
      newState.activeTabIndex = action.index;
      return newState;
    }
    case actionTypes.RESET_COUNTRY_FORM_TAB_INDEX: {
      let newState = {...state};
      newState.activeTabIndex = 0;
      return newState;
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/CaseBody/reducers/countryFormInfo.js